import { Image as ResponsiveImage, Section, useMaxWidth } from '@tracklib/kit'
import cn from 'clsx'

// Hooks
import { useDarkMode } from 'modules/profile/hooks'

import styles from './imageblock.css'

type ImageProps = {
  value: {
    image: number
    image_dark_mode?: number
    mobile_image: number
    mobile_image_dark_mode?: number
    caption: string
    alt_text: string
    fit_in_container: boolean
    full_width: boolean
  }
  isColumn?: boolean
}

const Image = ({
  value: { image, mobile_image, image_dark_mode, mobile_image_dark_mode, caption, alt_text, fit_in_container, full_width },
  isColumn,
}: ImageProps): JSX.Element => {
  const isSmall = useMaxWidth()
  const Element = full_width ? 'div' : Section
  const isDarkMode = useDarkMode()

  const getSizes = () => {
    if (full_width) {
      return '100vw'
    }
    if (isColumn) {
      return '(min-width: 769px) 40vw, 100vw'
    }
    return '(min-width: 769px) 50vw, 100vw'
  }

  const getImage = () => {
    if (isDarkMode) {
      return isSmall ? mobile_image_dark_mode || image_dark_mode || mobile_image || image : image_dark_mode || image
    }
    return isSmall ? mobile_image || image : image
  }

  return (
    <Element size={fit_in_container ? 'small' : 'medium'} className={styles.section}>
      <figure
        className={cn(
          styles.image,
          'image',
          isColumn && styles.isColumn,
          fit_in_container && styles.fitInContainer,
          full_width && styles.fullWidth,
        )}
      >
        <ResponsiveImage image={getImage()} sizes={getSizes()} alt={alt_text || caption} />
        {caption && <figcaption>{caption}</figcaption>}
      </figure>
    </Element>
  )
}

export default Image
